<section class="product-intro-banner" [attr.aria-labelledby]="resolvedHeadingId">
  <div class="product-intro-banner__content">
    <div class="product-intro-banner__copy">
      <header class="product-intro-banner__header">
        <p class="product-intro-banner__eyebrow">{{ eyebrow }}</p>
        <h1 class="product-intro-banner__title" [id]="resolvedHeadingId">{{ headline }}</h1>
      </header>

      <p class="product-intro-banner__description">{{ description }}</p>
      <p *ngIf="descriptionSecondParagraph" class="product-intro-banner__description">{{ descriptionSecondParagraph }}
      </p>

      <div class="product-intro-banner__actions">
        <c11n-button [class]="primaryCtaClass" [labelText]="primaryCtaLabel" [variant]="primaryCtaVariant"
          [iconName]="primaryCtaIconName" [iconPosition]="primaryCtaIconPosition" [fullWidth]="isStackedButtonLayout"
          size="medium" (clickEvent)="onPrimaryCtaClick()"></c11n-button>

        <c11n-button *ngIf="hasVideoSource" [labelText]="secondaryCtaLabel" [fullWidth]="isStackedButtonLayout"
          variant="secondary" size="medium" (clickEvent)="onWatchDemoClick()"></c11n-button>
      </div>
    </div>

    <div class="product-intro-banner__media-wrap">
      <div class="product-intro-banner__media">
        <img *ngIf="mediaImageSrc" class="product-intro-banner__image" [src]="mediaImageSrc" [alt]="mediaImageAlt" />

        <button *ngIf="hasVideoSource" class="product-intro-banner__play-button" type="button"
          [attr.aria-label]="resolvedWatchDemoAriaLabel" (click)="onWatchDemoClick()">
          <span class="product-intro-banner__play-icon" aria-hidden="true"></span>
        </button>
      </div>
    </div>
  </div>
</section>

<c11n-modal-dialog-entrypoint></c11n-modal-dialog-entrypoint>

<c11n-modal-dialog [modalId]="'productIntroVideoModal'" [headingText]="resolvedVideoTitle" [maxWidth]="1000"
  [useContentWidth]="true" [primaryButtonLabel]="''" [secondaryButtonLabel]="''"
  (closeSourceEvent)="onVideoModalClosing()" (closeEvent)="onVideoModalClose()" #productIntroVideoModalDialog>
  <div c11n-modal-dialog-body class="product-intro-banner-modal__body">
    <app-video-player *ngIf="isVideoPlayerVisible" [videoSrc]="videoSrc" [title]="resolvedVideoTitle"
      [videoHeight]="540" [videoWidth]="960"></app-video-player>

    <div *ngIf="hasVideoSource && isVideoPlayerVisible" class="product-intro-banner-modal__transcript">
      <div class="product-intro-banner-modal__transcript-header">
        <button class="product-intro-banner-modal__transcript-toggle" type="button"
          [attr.aria-expanded]="isTranscriptExpanded" [attr.aria-controls]="resolvedHeadingId + '-transcript'"
          (click)="onTranscriptToggle()">
          <img class="product-intro-banner-modal__transcript-chevron"
            [class.product-intro-banner-modal__transcript-chevron--open]="isTranscriptExpanded"
            src="assets/icons/transcript-chevron.svg" alt="" aria-hidden="true" />
          <span>{{ 'shared.productIntroBanner.videoTranscript' | translate }}</span>
        </button>
      </div>

      <div [id]="resolvedHeadingId + '-transcript'" class="product-intro-banner-modal__transcript-body"
        [hidden]="!isTranscriptExpanded" role="region"
        [attr.aria-label]="'shared.productIntroBanner.videoTranscript' | translate">
        <wistia-transcript class="product-intro-banner-modal__wistia-transcript"
          [attr.media-id]="videoSrc"></wistia-transcript>
      </div>
    </div>
  </div>
</c11n-modal-dialog>